'use strict';
var lory = require('lory.js').lory;

var MOBILE_WIDTH = 768;

(function (exports) {

    /**
     * Banner - Javascript is used to calculate the background color
     * @param element 
     */
    function Banner(element) {
        this.initBackgroundColor(element);
    }

    Banner.prototype.initBackgroundColor = function (element) {
        var infoPanel = element.querySelector('.amp-dc-banner-info');
        var dataColor = infoPanel.getAttribute('data-color') || 'fff';
        var dataOpacity = Number(infoPanel.getAttribute('data-opacity') || '1');

        if (dataColor.indexOf('#') === 0) {
            dataColor = dataColor.slice(1);
        }

        if (dataColor.length === 3) {
            var hexArr = dataColor.split('');
            dataColor = hexArr[0] + hexArr[0];
            dataColor += hexArr[1] + hexArr[1];
            dataColor += hexArr[2] + hexArr[2];
        }

        var r = parseInt(dataColor.slice(0, 2), 16);
        var g = parseInt(dataColor.slice(2, 4), 16);
        var b = parseInt(dataColor.slice(4, 6), 16);

        infoPanel.style.backgroundColor = 'rgba(' + r + ', ' + g + ', ' + b + ', ' + dataOpacity + ')';
    }

    /**
     * Promo Banner - Javascript is used to animate the sections for resolutions that can only show a single section at a time
     * @param element 
     */
    function PromoBanner(element) {
        var $children = [].slice.call(
            element.querySelectorAll('.amp-dc-promo-block')
        );
        var currentItemNum = 2;
        var winWidth = window.innerWidth;

        if ($children.length < 2) {
            $children[0].classList.add('dc-fade-in');
            return;
        }

        $children.forEach(function ($child) {
            $children[currentItemNum - 1].classList.remove('dc-fade-in');
        });

        $children[currentItemNum - 1].classList.add('dc-fade-in');

        var getNextItem = function () {
            if (currentItemNum === $children.length) {
                currentItemNum = 1;
            } else {
                currentItemNum += 1;
            }

            return currentItemNum - 1;
        };

        setInterval(function () {
            winWidth = window.innerWidth;
            var $fadedElems = [].slice.call(
                element.querySelectorAll('.dc-fade-in')
            );
            if (winWidth > 768) {
                return;
            }

            var itemToShow = getNextItem();
            if ($fadedElems.length > 0) {
                $fadedElems.forEach(function ($fadeElem) {
                    $fadeElem.classList.remove('dc-fade-in');
                });
            }
            $children[itemToShow].classList.add('dc-fade-in');
        }, 5000);
    }

    var enableAutoplayTimer = function (slider, speed) {
        return setInterval(function () {
            slider.next();
        }, speed * 1000);
    };

    /**
     * Slider - Javascript is used to add animation and navigation functionality to the slider
     * @param element 
     */
    function Slider(element) {
        var data = {
            infinite: false,
            navigation: element.getAttribute('data-navigation') === 'true',
            autoplay: element.getAttribute('data-autoplay') === 'true',
            speed: parseFloat(element.getAttribute('data-speed')),
            slideSpeed: element.getAttribute('data-slide-speed') ? parseFloat(element.getAttribute('data-slide-speed')) : 500,
            rewindOnResize: false
        };

        var easeType = element.getAttribute('data-slide-ease');
        if (!easeType || !easeType.length || easeType === 'linear') {
            data.ease = easeType;
        }

        var slider = lory(element, data);

        this.lorySlider = slider;
        this.data = data;

        this.offsetNavButtons(element);

        if (!data.infinite) {
            this.disableNavButtons(element, slider);
        }

        if (data.navigation) {
            this.navigationDots(element, slider, data);
        }

        this.enableSwipeGesturesOnVideo(element);

        if (data.autoplay) {
            this.timer = enableAutoplayTimer(slider, data.speed);
            this.stopAnimation = false;
        }
    }

    Slider.prototype.offsetNavButtons = function (element) {
        var arrows = element.querySelectorAll('.js_slider_toggle');

        var sliderOptions = {
            separation: element.getAttribute('data-separation'),
            slideMarginBottom: element.getAttribute('data-slide-margin-bottom'),
            slidePaddingBottom: element.getAttribute('data-slide-margin-bottom'),
            titleMarginBottom: element.getAttribute('data-title-margin-bottom'),
            titleMarginTop: element.getAttribute('data-title-margin-top'),
            titlePaddingBottom: element.getAttribute('data-title-padding-bottom'),
            titlePaddingTop: element.getAttribute('data-title-padding-top'),
            titleFontSize: element.getAttribute('data-title-font-size'),
            subtitleMarginBottom: element.getAttribute('data-subtitle-margin-bottom'),
            subtitleMarginTop: element.getAttribute('data-subtitle-margin-top'),
            subtitlePaddingBottom: element.getAttribute('data-subtitle-padding-bottom'),
            subtitlePaddingTop: element.getAttribute('data-subtitle-padding-top'),
            subtitleFontSize: element.getAttribute('data-subtitle-font-size')
        };

        var reverseOptions = {
            slideMarginTop: element.getAttribute('data-slide-margin-top'),
            slidePaddingTop: element.getAttribute('data-slide-margin-top')
        };

        var offset = '';

        var valuesSubtract = Object.values(sliderOptions);
        for (var i = 0; i < valuesSubtract.length; i++) {
            offset += valuesSubtract[i] + ' / 2 ';

            if (i < valuesSubtract.length - 1) {
                offset += ' - ';
            }
        }

        offset += ' + ';

        var valuesAdd = Object.values(reverseOptions);
        for (var i = 0; i < valuesAdd.length; i++) {
            offset += valuesAdd[i] + ' / 2 ';

            if (i < valuesAdd.length - 1) {
                offset += ' + ';
            }
        }

        if (offset.length) {
            Array.from(arrows).forEach(function (arrow) {
                arrow.style.top = 'calc(50% - ' + offset + ')';
            })
        }
    }

    var stopAutoPlay = function (element) {
        clearInterval(element.component.timer);
        element.component.timer = null;
    };

    var enableAutoPlay = function (element) {
        if (element.component.data.autoplay && !element.component.timer) {
            element.component.timer = enableAutoplayTimer(element.component.lorySlider, element.component.data.speed);
        }
    };

    Slider.prototype.disableNavButtons = function (element, sliderInstance) {
        var $slides = Array.prototype.slice.call(
            element.querySelectorAll('.js_dc_slide'),
            0
        );
        var $prevButton = element.querySelector('.js_prev');
        var $nextButton = element.querySelector('.js_next');
        var disabledClass = 'ctrl-disabled';

        var navButtonsBehave = function (evt) {
            var slides = element.querySelectorAll('.amp-dc-slide');
            var slideCount = slides.length;
            var perView = element.getAttribute('data-display');
            var mobileLayout = element.getAttribute('data-mobile') === 'true';

            if (mobileLayout && document.body.clientWidth <= MOBILE_WIDTH) {
                perView = 1;
            }

            var slideIndex = sliderInstance.returnIndex();

            if (slideCount === parseInt(perView)) {
                $prevButton.classList.add(disabledClass);
                $nextButton.classList.add(disabledClass);
            } else if (slideIndex === 0) {
                $prevButton.classList.add(disabledClass);
                $nextButton.classList.remove(disabledClass);
            } else if (slideIndex + parseInt(perView) === $slides.length) {
                $prevButton.classList.remove(disabledClass);
                $nextButton.classList.add(disabledClass);
            } else {
                $prevButton.classList.remove(disabledClass);
                $nextButton.classList.remove(disabledClass);
            }
        };

        navButtonsBehave(null);

        element.addEventListener('after.lory.slide', navButtonsBehave);
        element.addEventListener('on.lory.resize', navButtonsBehave);

        element.addEventListener('mouseover', function () {
            stopAutoPlay(element);
        });
        element.addEventListener('mouseout', function () {
            enableAutoPlay(element);
        });
        element.addEventListener('touchstart', function () {
            stopAutoPlay(element);
        });
        element.addEventListener('touchend', function () {
            enableAutoPlay(element);
        });
    }

    Slider.prototype.navigationDots = function (element, sliderInstance, sliderSettings) {
        var dots = Array.prototype.slice.call(
            element.querySelectorAll('.js_dc_slider_dot'),
            0
        );

        var attachNavEvents = function () {
            dots.forEach(function ($dot, ind) {
                if (ind === 0) {
                    $dot.classList.add('active');
                }
                $dot.addEventListener('click', function (evt) {
                    sliderInstance.slideTo(ind);
                });
            });
        };

        var selectActiveDot = function (evt) {
            dots.forEach(function ($dot, ind) {
                $dot.classList.remove('active');
            });

            var currentSlide = sliderSettings.infinite ?
                evt.detail.currentSlide - 1 :
                evt.detail.currentSlide;
            dots[currentSlide].classList.add('active');
        };

        var resetToFirst = function () {
            dots.forEach(function ($dot, ind) {
                ind === 0 ?
                    $dot.classList.add('active') :
                    $dot.classList.remove('active');
            });
        };

        attachNavEvents();
        element.addEventListener('after.lory.slide', selectActiveDot);
        element.addEventListener('on.lory.resize', resetToFirst);
    }

    Slider.prototype.enableSwipeGesturesOnVideo = function (element) {
        if (navigator.userAgent.match(/Android/i)) {
            var videos = element.querySelectorAll(
                '.amp-dc-slider .amp-dc-video, .amp-dc-carousel .amp-dc-video'
            );
            videos = Array.prototype.slice.call(videos, 0);
            videos.forEach(function (video, ix) {
                var overlay = document.createElement('div');
                overlay.style.width = video.clientWidth + 'px';
                overlay.style.height = video.clientHeight - 30 + 'px';
                overlay.style.marginBottom = -video.clientHeight + 30 + 'px';
                overlay.className = 'inactive-video';
                video.parentNode.parentNode.insertBefore(
                    overlay,
                    video.parentNode
                );
                overlay.addEventListener('click', function () {
                    overlay.classList.add('no-overlay');
                    video.play();
                });
                video.addEventListener('pause', function () {
                    overlay.classList.remove('no-overlay');
                });
                window.addEventListener('resize', function () {
                    overlay.style.width = video.clientWidth + 'px';
                    overlay.style.height = video.clientHeight - 30 + 'px';
                    overlay.style.marginBottom = -video.clientHeight + 30 + 'px';
                });
            });
        }
    }


    /**
     * The code below finds dom elements output from templates
     * and invokes the associated Javascript component
     */

    function attachComponent(selector, component) {
        [].slice.call(document.querySelectorAll(selector))
            .forEach(function (element) {
                if (!element.component) {
                    element.component = new component(element);
                }
            });
    }

    function attachComponents() {
        attachComponent('.amp-dc-banner', Banner);
        attachComponent('.amp-dc-promo-banner', PromoBanner);
        attachComponent('.amp-dc-slider', Slider);
        attachComponent('.amp-dc-carousel', Slider);
    }

    exports.Utils = exports.Utils || {};
    exports.Utils.attachComponents = attachComponents;

    /**
     * Automatically activate accelerator components when the page renders
     */
    document.addEventListener('DOMContentLoaded', function() {
        attachComponents();
    });

})(
    window.AmpCa = window.AmpCa || {}
);
